import Vue from 'vue';

export const mcEvents = {
  loggedIn: 'loggedIn',
  itemSaved: 'itemSaved',
  linesMerged: 'linesMerged',
  kickedFromServingLine: 'kickedFromServingLine',
  tallyNotify: 'tallyNotify',
  syncedMealsDown: 'syncedMealsDown',
  selectionsCleared: 'selectionsCleared',
  sessionTimedOut: 'sessionTimedOut',
  serveClicked: 'servedClicked',

  // SignalR events
  deselectedDashboardSite: 'deselectedDashboardSite',
  selectedDashboardSite: 'selectedDashboardSite',
  enteredCountingWorkflow: 'enteredCountingWorkflow',
  exitedCountingWorkflow: 'exitedCountingWorkflow',
  receiveUpdatedCount: 'receiveUpdatedCount',
  continueToServe: 'continueToServe',
  sendMealCounts: 'sendMealCounts',
  mergedLines: 'mergedLines'
};

// our event bus instance is just a new Vue!
// we use $on() as subscribe and $emit() as publish.
// while the main vue instances work for most things, this lets us add event messaging to services.
export const eventBus = new Vue();
